import { Component, inject, OnInit } from '@angular/core';
import { TabManagerService } from './hezky-routes';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  tabManagerService = inject(TabManagerService);
  ngOnInit(): void { }
}
